import { render } from "./studioList.vue?vue&type=template&id=6a0ea339&scoped=true"
import script from "./studioList.vue?vue&type=script&lang=js"
export * from "./studioList.vue?vue&type=script&lang=js"

import "./studioList.vue?vue&type=style&index=0&id=6a0ea339&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a0ea339"]])

export default __exports__